export default __webpack_public_path__ + "static/media/ic_no_reviews.ae7f0105.png";